import * as React from 'react';
import ReactDOM from 'react-dom';
import Datatable from "../../DataTable";
import { formTableColumns, formTableOptions } from "./config"
import { UserInfo } from "../../Login/common/defaults";
import { Button } from 'react-bootstrap';

interface IFormListUIProps {
    forms:any[];
    selectFormToEdit:(id:string) => void;
    copyForm:(form:any) => void;
    history:any;
}

export default class FormListUI extends React.Component<IFormListUIProps,any> {

    render() {
        const formTablecolumnDefs = [
            {
              targets: 0,
              orderable:false,
              createdCell: (td, cellData, rowData, row, col) => {
                return ReactDOM.render(
                  <div>
                    <i className="fas fa-edit pointer cell-fas" data-id={cellData} onClick={() => {this.props.selectFormToEdit(rowData.path)}}></i>
                    <i className="fas fa-copy pointer cell-fas" data-id={cellData} onClick={() => {this.props.copyForm(rowData.path)}}></i>
                  </div>,
                  td
                );
              }
            }
        ];

        return (
          <React.Fragment>
            <Button style={{width:"150px"}} onClick={() => this.props.history.push("/ImportForm")}>Import a Form</Button>
            <Datatable id="tblFormAdministration" columns={formTableColumns} {...formTableOptions} data={this.props.forms} columnDefs={formTablecolumnDefs} />
          </React.Fragment>
        )
    }
}
